<template>
    <div>
    <!-- Breadcrumb Section Begin -->
    <div class="breacrumb-section" v-if="Produto!=''">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-text product-more">
                        <router-link to="/"><i class="fa fa-home"></i> {{ $t('nav.home') }}</router-link>
                        <router-link :to="'/Produtos/' + Produto.proProdutosSegmentos[0].proSegmentos.psgId + '/' + Produto.proProdutosSegmentos[0].proSegmentos.psgNomeSegmento.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">{{ $localeField(Produto.proProdutosSegmentos[0].proSegmentos, 'psgNomeSegmento') }}</router-link>
                        <span>{{ $localeField(Produto, 'proNomeProduto') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Breadcrumb Section Begin -->

    <!-- Product Shop Section Begin -->
    <section class="product-shop spad page-details" v-if="Produto!=''">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-5">
                            <div class="product-details">
                                <div class="pd-title">
                                    <span></span>
                                    <h3>{{ $localeField(Produto, 'proNomeProduto') }}</h3>
                                </div>
                                <ul class="pd-tags">
                                    <li><span>{{ $t('product.date') }}:</span> {{ $localeField(Produto, 'proCampoExtra7') }}</li>
                                    <li><span>{{ $t('product.type') }}:</span> {{ $localeField(Produto, 'proReferencia') }}</li>
                                    <li><span>{{ $t('product.distance') }}:</span> {{ $localeField(Produto, 'proCampoExtra2') }}</li>
                                    <li><span>{{ $t('product.country') }}:</span> {{ $localeField(Produto, 'proCampoExtra3') }}</li>
                                </ul>
                                <div class="pd-desc">
                                    <p v-html="$localeHtml(Produto, 'proTexto1')"></p>
                                    <h4>{{ $t('home.fromPrice') }} R$ {{ formatarValor(Produto.proValorPor) }}</h4>
                                </div>
                                <div class="quantity" v-if="contato!=''">
                                    <a 
                                        :href="`${contato[0].itiCampoExtra7}&text=${encodeURIComponent($t('product.buyThisPackage') + ' ' + $localeField(Produto, 'proNomeProduto'))}`"  target="_blank"
                                        class="primary-btn pd-cart">
                                        {{ $t('product.buyThisPackage') }}
                                        </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-7">
                            <div class="product-item pi-pic sale" v-if="Produto.proEtiqueta != '' && Produto.proEtiqueta != null"
                                        :style="{
                                            color: Produto.proEtiquetaCorFonte ? `${Produto.proEtiquetaCorFonte} !important` : '#FFFFFF !important', 
                                            backgroundColor: Produto.proEtiquetaCorFundo ? `${Produto.proEtiquetaCorFundo} !important` : '#76BC42 !important'
                                        }" style="position: absolute; padding: 20px;"
                                        >{{ $localeField(Produto, 'proEtiqueta') }}</div>
                            <img :src="$imgURL + Produto.proProdutosImagens[0].pimUrlImagem" style="width: 100%;height: auto;border-radius: 5px;" />
                        </div>
                    </div>
                   

                    <div class="product-tab">
                        <!-- Aba de navegação -->
                        <div class="tab-item">
                        <ul class="nav" role="tablist">
                            <li>
                            <a :class="{ active: activeTab === 'tab-1' }" @click.prevent="activeTab = 'tab-1'" role="tab" style="cursor: pointer;">
                                {{ $t('product.description') }}
                            </a>
                            </li>
                            <li>
                            <a :class="{ active: activeTab === 'tab-2' }" @click.prevent="activeTab = 'tab-2'" role="tab" style="cursor: pointer;">
                                {{ $t('product.details') }}
                            </a>
                            </li>
                            <li>
                            <a :class="{ active: activeTab === 'tab-3' }" @click.prevent="activeTab = 'tab-3'" role="tab" style="cursor: pointer;">
                                {{ $t('product.included') }}
                            </a>
                            </li>
                            <li v-if="Produto.proProdutosGrids.filter(x=> x.proListaGaleriaGrids.plgId == 4).length > 0">
                            <a :class="{ active: activeTab === 'tab-4' }" @click.prevent="activeTab = 'tab-4'" role="tab" style="cursor: pointer;">
                                {{ $t('product.hotels') }}
                            </a>
                            </li>
                            <li v-if="Produto.proCampoExtra5 != '' || Produto.proCampoExtra6 !=''">
                            <a :class="{ active: activeTab === 'tab-5' }" @click.prevent="activeTab = 'tab-5'" role="tab" style="cursor: pointer;">
                                {{ $t('product.videos') }}
                            </a>
                            </li>
                            <li v-if="Produto.proCampoExtra4 != ''">
                            <a :class="{ active: activeTab === 'tab-6' }" @click.prevent="activeTab = 'tab-6'" role="tab" style="cursor: pointer;">
                                {{ $t('product.registration') }}
                            </a>
                            </li>
                        </ul>
                        </div>

                        <!-- Conteúdo das Abas -->
                        <div class="tab-item-content">
                        <div class="tab-content">
                            <!-- Aba Descrição -->
                            <div v-if="activeTab === 'tab-1'" class="tab-pane active" role="tabpanel">
                            <div class="product-content">
                                <div class="row">
                                <div class="col-lg-6">
                                    <h5>{{ $t('product.description') }}</h5>
                                    <p v-if="Produto.proTexto2 != ''" v-html="$localeHtml(Produto, 'proTexto2')"></p>
                                    <p v-else v-html="$localeHtml(Produto, 'proTexto1')"></p>
                                </div>
                                <div class="col-lg-6">
                                    <div class="main-image">
                                        <img :src="$imgURL + selectedImage" alt="Imagem do Produto" />
                                    </div>
                                    <div class="thumbnails">
                                        <img 
                                            v-for="(imagem, index) in Produto.proProdutosImagens" 
                                            :key="index" 
                                            :src="$imgURL + imagem.pimUrlImagem" 
                                            @click="selectedImage = imagem.pimUrlImagem"
                                            class="thumbnail-image"
                                            :class="{ 'active-thumbnail': selectedImage === imagem.pimUrlImagem }"
                                            alt="Miniatura do Produto" 
                                        />
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>

                            <!-- Aba Detalhes -->
                            <div v-if="activeTab === 'tab-2'" class="tab-pane active" role="tabpanel">
                            <div class="specification-table" style="width: 100%; overflow-x: scroll;">
                                <table>
                                <tr v-for="det in Produto.proProdutosGrids.filter(x=> x.proListaGaleriaGrids.plgId == 1)" :key="det.pgsId">
                                    <td class="p-catagory">{{ $localeField(det, 'pgsNome') }}</td>
                                    <td>
                                    <div class="p-stock">{{ $localeField(det, 'pgsCampoExtra1') }}</div>
                                    </td>
                                </tr>
                                </table>
                            </div>
                            </div>
                             <!-- incluidos -->               
                            <div v-if="activeTab === 'tab-3'" class="tab-pane active" role="tabpanel">
                            <div class="specification-table" style="width: 100%; overflow-x: scroll;">
                                <table>
                                    <tr v-for="inc in Produto.proProdutosGrids.filter(x=> x.proListaGaleriaGrids.plgId == 3)" :key="inc.pgsId">
                                        <td>
                                            <div class="p-stock">{{ $localeField(inc, 'pgsCampoExtra1') }}</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            </div>

                            <div v-if="activeTab === 'tab-4'" class="tab-pane active" role="tabpanel">
                                <div class="product-content">
                                    <div class="row" v-if="Hoteis != ''">
                                        <div class="col-lg-6" v-for="Hot in Hoteis" :key="Hot.itiId">
                                            <h5 style="padding-bottom: 10px;">{{ $localeField(Hot, 'itiNome') }}</h5>
                                            <div class="main-image">
                                                <img :src="$imgURL + Hot.selectedImage" alt="Imagem do Produto" />
                                            </div>
                                            <div class="thumbnails">
                                                <img 
                                                    v-for="(imagem, index) in Hot.insInstitucionalImagens" 
                                                    :key="index" 
                                                    :src="$imgURL + imagem.itgUrlImagem" 
                                                    @click="Hot.selectedImage = imagem.itgUrlImagem"
                                                    class="thumbnail-image"
                                                    :class="{ 'active-thumbnail': Hot.selectedImage === imagem.itgUrlImagem }"
                                                    alt="Miniatura do Produto" 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div v-if="activeTab === 'tab-5'" class="tab-pane active" role="tabpanel">
                            <div class="specification-table" style="width: 100%; overflow-x: scroll;">
                                <table>
                                <tr>
                                    <td>
                                        <div class="container">
                                            <div class="row">
                                                <div class="col-lg-6" v-if="Produto.proCampoExtra5!=''">
                                                    <iframe width="100%" height="315" :src="Produto.proCampoExtra5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                                </div>
                                                <div class="col-lg-6" v-if="Produto.proCampoExtra6!=''">
                                                    <iframe width="100%" height="315" :src="Produto.proCampoExtra6" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                                </div>
                                            </div>
                                        </div>                                             
                                    </td>
                                </tr>
                            </table>
                            </div>
                            </div>

                            <div v-if="activeTab === 'tab-6'" class="tab-pane active" role="tabpanel">
                            <div class="specification-table" style="width: 100%; overflow-x: scroll;">
                                <table>
                                    <tr>
                                        <td>
                                            <div class="p-stock">{{ $t('product.registrationText') }}</div>
                                            <div>
                                                <a :href="Produto.proCampoExtra4" class="btn" target="_blank" style="color:#ffffff;"> {{ $t('product.clickHere') }}</a>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            </div>

                        </div>
                        </div>
                    </div>

               </div>
            </div>
        </div>
    </section>
    <!-- Product Shop Section End -->
    </div>


</template>

<script>
//import moment from 'moment'
import axios from 'axios';
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';



export default {
    name: 'ProdutoDetalheView',
    setup() {
        const route = useRoute();
        const id = route.params.idProduto;
        const nomeProduto = route.params.nomeProduto;
        return {
            id
        };
    },
    components: {
    },
    data: () => ({
        Produto: [],
        ProdutoImg:[],
        infocall:[],
        valorTotal:0,
        vProdutosExtras:[],
        ProdutoAvulsos:[],
        DadosCompra: {
            produtos: [],
            mensagem: [],
            agenda: [],
            foto: [],
            avulsos: [],
            baloes: [],
            informacao: [],
            pagamento: [],
            cupom: [],
        },
        ProdutoPreco:[],
        dialog: false,
       activeTab: 'tab-1',
       selectedImage: '',
       selectedImage2:'',
       contato:[],
       Hoteis:[],
       ListHoteis:[],
    }),
    methods: {
        carregaMetas(titulo) {
            useHead({
                title: titulo + ' - Sub4 Turismo'
            })
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
    },
    created() {
        

        axios.get('/Process/InsInstitucional/institucional/16/contato')
        .then(response => {
            this.contato = response.data;
        })
        .catch(error => {
            console.error(error);
        });

        if (this.id != null && this.id != '') {
            axios.get('/Process/ProProdutos/GetById/' + this.id)
            .then(response => {
                this.Produto = response.data;
                this.carregaMetas(this.$localeField(this.Produto, 'proNomeProduto'));

                if (this.Produto.proProdutosImagens != '') {
                    this.ProdutoImg = this.Produto.proProdutosImagens.filter(x => x.pimVisivel).sort((a, b) => {
                        const valorA = parseInt(a.pimOrdem) || 0;
                        const valorB = parseInt(b.pimOrdem) || 0;
                        return valorA - valorB;
                    });
                }

                this.Produto.proProdutosGrids.sort((a, b) => {
                    const valorA = parseInt(a.pgsOrdem) || 0;
                    const valorB = parseInt(b.pgsOrdem) || 0;
                    return valorA - valorB;
                });

                this.ListHoteis = this.Produto.proProdutosGrids.filter(x => x.proListaGaleriaGrids.plgId == 4).sort((a, b) => {
                    const valorA = parseInt(a.pgsOrdem) || 0;
                    const valorB = parseInt(b.pgsOrdem) || 0;
                    return valorA - valorB;
                });

                // Use Promise.all para aguardar todas as requisições
                const hotelPromises = this.ListHoteis.map(element => 
                    axios.get('/Process/InsInstitucional/GetById/' + element.pgsCampoExtra2)
                        .then(response => response.data)
                );

                return Promise.all(hotelPromises);
            })
            .then(hoteis => {
                // Adicione os hotéis ao array
                this.Hoteis = hoteis;

                // Adicione a propriedade `selectedImage` a cada hotel
                this.Hoteis.forEach(hotel => {
                    hotel.selectedImage = hotel.insInstitucionalImagens.length ? hotel.insInstitucionalImagens[0].itgUrlImagem : ''; 
                });

                if (this.Produto.proProdutosImagens.length > 0) {
                    this.selectedImage = this.Produto.proProdutosImagens.sort((a, b) => {
                        const valorA = parseInt(a.pimOrdem) || 0;
                        const valorB = parseInt(b.pimOrdem) || 0;
                        return valorA - valorB;
                    })[0].pimUrlImagem;
                }

            // console.log('this.Produto', this.Produto);
            // console.log('this.Hoteis', this.Hoteis);
            })
            .catch(error => {
                console.error(error);
            });

            

       }
    },
  
}
</script>

<style>

.nav a.active {
  font-weight: bold;
  color: #007bff;
}
.tab-pane {
  display: none;
}
.tab-pane.active {
  display: block;
}

.main-image img {
  width: 100%;
  height: auto;
  display: block;
  margin-bottom: 10px;
}

.thumbnails {
  display: flex;
  gap: 5px;
}

.thumbnail-image {
  width: 60px;
  height: 60px;
  cursor: pointer;
  border: 2px solid transparent;
}

.thumbnail-image.active-thumbnail {
  border-color: #007bff;
}

@media (min-width:1200px) {

    .fonttext{
        font-size: 14px;
    }
    /* Estilos para o select */
.styled-select {
  display: block;
  width: 100%;
  font-size: 15px;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.altcel {
    min-height: 500px !important;
    height: auto !important;
}

.altavul {
    padding-top: 25px;
}

.btncel {
    color:#ffffff;
    min-width:80px !important;
    font-size: 18px;
}
}

@media (min-width:768px) {
    .altavul {
    padding-top: 35px;
}

.fonttext{
        font-size: 14px;
    }
    /* Estilos para o select */
.styled-select {
  display: block;
  width: 100%;
  font-size: 15px;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.altcel {
    min-height: 500px !important;
    height: auto !important;
}

.altavul {
    padding-top: 25px;
}

.btncel {
    color:#ffffff;
    min-width:80px !important;
    font-size: 18px;
}
}


@media (max-width:767px) {

    .fonttext{
        font-size: 12px;
    }

    .altcel {
    min-height: 300px !important;
    height: auto !important;
}
.altavul {
    padding-top: 5px;
}

.text-h5{
    font-size: 15px !important;
}

.btncel {
    color:#ffffff;
    min-width:80px !important;
    padding: 0 !important;
     font-size: 12px;
}

/* Estilos para o select */
.styled-select {
  display: block;
  width: 100%;
  font-size: 12px;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.v-toolbar-title__placeholder {
    overflow: auto;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.v-toolbar-title {
    flex: auto !important;
    font-size: 1.25rem;
    min-width: 0;
    font-size: 1.25rem;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 1.75rem;
    text-transform: none;
}

}



.hhss {
    display: none;
}

.sli p {
    color: #ede3e3 !important;
}

.border-green {
    border: 4px solid green !important; /* Defina a cor e largura da borda */
    border-radius: 8px; /* Adicione um raio de borda para suavizar a aparência */
}

.check-icon {
    position: absolute;
    bottom: 5px; /* Ajuste conforme necessário */
    right: 5px; /* Ajuste conforme necessário */
    color: green;
    background-color: white;
    border-radius: 50%;
    padding: 5px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5); /* Adiciona sombra para destaque */
}

.v-card {
    position: relative; /* Isso garante que o ícone absoluto esteja posicionado em relação a este cartão */
}

    .v-dialog > .v-overlay__content {
        max-height: calc(100% - 128px);
        width: calc(100% - 48px);
        max-width: calc(100% - 6px) !important;
        margin: 24px;
        display: flex;
        flex-direction: column;
    }


    /* Estilos para o wrapper do select */
.v-select-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}



/* Estilos para o ícone de dropdown */
.caret {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  pointer-events: none;
}


</style>
